import { Component } from '@angular/core';
import { SharedService } from './shared/shared.service';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'app';
  public navMenu:boolean;
  public timeoutMin: number = environment.timeoutMinute;
  constructor(private sharedService : SharedService){}

  ngDoCheck(){
  	this.navMenu = this.sharedService.navMenu;
  }
  public callSessionExpiry() {
    if(this.sharedService.isUserLoggedIn()){
      this.sharedService.sessionExpireyRedirection();
    }
  }
}



// WEBPACK FOOTER //
// C:/Agent0/_work/434/s/src/app/app.component.ts